import Model from './Model'

export default class Meal extends Model {
  resource() {
    return 'meals'
  }
}
